export async function getQuiz(slug?: string) {
  return fetch(window.env.QUIZ_API_URL + `/api/quiz/slug/${slug}`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then((response) => response.json());
}
